import React from 'react';
import classnames from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Tab from './Tab';
export const Tabs = /*#__PURE__*/ React.forwardRef(({ width, className, viewClassNames: s, items, activeIndex, extraTabs, onChange, activeItemRef, rootTag: RootTag = 'div', a11yHeading }, ref)=>{
    return /*#__PURE__*/ React.createElement(RootTag, {
        // @ts-ignore - Dynamic tags with ref passing is hard for typescript to understand
        className: classnames(s['root'], className),
        style: {
            width
        },
        ref: ref
    }, a11yHeading && /*#__PURE__*/ React.createElement(VisuallyHidden, null, /*#__PURE__*/ React.createElement(Heading, null, a11yHeading)), items.map((item)=>/*#__PURE__*/ React.createElement(Tab, {
            key: item.index,
            viewClassNames: s,
            label: /*#__PURE__*/ React.createElement(React.Fragment, null, item.label, item.labelExtras),
            href: item.href,
            prefix: item.prefix,
            postfix: item.tabExtras,
            dropdown: item.tabDropdown,
            biData: item.biData,
            isActive: item.index === activeIndex,
            "data-hook": item.dataHook,
            onClick: onChange && (()=>onChange(item.index)),
            innerRef: item.index === activeIndex ? activeItemRef : undefined
        })), extraTabs);
});
Tabs.displayName = 'Tabs';
export default Tabs;

//# sourceMappingURL=Tabs.js.map